export const EnglishSpeakingIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 1 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width={width} height={height} rx="12" fill="white" />
        <path
          d="M3.744 12.428H8.784V13.618H3.744V12.428ZM3.87 16.782H9.582V18H2.47V8.2H9.386V9.418H3.87V16.782ZM12.2689 18V8.2H13.4169L19.8989 16.25H19.2969V8.2H20.6969V18H19.5489L13.0669 9.95H13.6689V18H12.2689Z"
          fill="#696F79"
        />
      </svg>
    </div>
  );
};
